import { SortBarItemProps, useTranslations } from "@mzara/component";

export const useSortBarItems = (): Array<SortBarItemProps> => {
    const [TITLE, DATE] = useTranslations(i18n);

    return [
        { label: TITLE, value: "title" },
        { label: DATE, value: "updatedAt", className: "ml-auto" },
    ];
};

const i18n = ["std_title", "std_date"];
